import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;

  .subHeader {
    display: flex;
    align-items: flex-end;
    gap: 0.5rem;

    h1 {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 1.1rem;
      margin: 0;
      width: 100%;
      font-weight: 600;
      max-width: 20rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 85%;
  gap: 0.2rem;

  .sendMessage {
    display: flex;
    position: relative;
    width: 100%;
    flex-direction: row-reverse;
    align-items: center;
    gap: 0.5rem;
    justify-content: flex-end;
    .iccDo {
      border: 2px solid ${({ theme }) => theme.colors.tertiary_500};
      border-radius: 1.5rem;
    }
    .recorded-audio {
      display: flex;
      width: 100%;

      audio {
        width: 75%;
      }
    }
    .MuiOutlinedInput-input {
      padding: 0.6rem 2.5rem 0.6rem 0.6rem;
    }
    .iccDo .MuiOutlinedInput-notchedOutline {
      border-color: transparent;
    }
    .icons {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      gap: 0.5rem;
      display: flex;
      justify-content: flex-end;

      button {
        color: ${({ theme }) => theme.colors.tertiary_500};
        background-color: transparent;
        width: auto;
        height: auto;
        padding: 0;
        margin-bottom: 0;
        padding: 0;
        border: 0;
        transition: opacity 0.2s;

        :hover {
          opacity: 0.6;
          cursor: pointer;
        }

        svg {
          margin: 0.2rem;
        }
      }
    }
  }
`;
